const Adler32 = require("adler32-js");
const hash = new Adler32();

module.exports.hashed = (text) => {
  return hash.update(text);
};
